// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Open_Sans_0d2434', '__Open_Sans_Fallback_0d2434'","fontStyle":"normal"},"className":"__className_0d2434"};